import React, { useState } from 'react'
import Header from '../../../requests/makeRequest/header/Header'
import RequestForm from '../../../requests/makeRequest/stepper/step4/RequestForm'
import Dialog from '../../../../components/dialog/Dialog'
import { hideModal } from '../../../reducers/modal/actions'
import { modalTypes } from '../../../../enums/modalTypeEnum'
import { FormattedMessage, useIntl } from 'react-intl'
import { connect, useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import { getModalContent, isModalVisible } from '../../../reducers/modal/selector'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../styles'
import { useMediaQuery } from 'react-responsive'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { SpecificationsModel } from '../../../requests/requestsModel'
import fetchFactory from '../../../../utils/fetchFactory'
import { configEnum } from '../../../../enums/fetchFactoryEnum'
import errorCatcher from '../../../../utils/errorCatcher'
import RequestSummary from '../../../requests/makeRequest/stepper/step5/RequestSummary'
import { ContractsModel, ContractsOmission } from '../../../../types/contracts/contractsModel'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			formLargeScreenStyle: {
				width: '60%',
				maxWidth: 900,
				margin: '25px auto 0'
			},
			formSmallScreenStyle: {
				marginTop: 40
			}
		}
	)
)

const ERROR_CATCHER_ID: string = 'response_form'

interface Store {
	contracts: Omit<ContractsModel, ContractsOmission>[],
}

interface ServiceModalModel {
	id_crm: string,
	title: string,
	callback?: () => {}
}

interface DataModel {
	description: string,
	title: string,
	id_crm: string,
	eft_Locataire: string,
	eft_BailId: string,
	eft_bienId: string
}

type ServiceModalProps = Store

const ServiceModal: React.FC<ServiceModalProps> = (
	{
		contracts
	}
) => {
	const classes = useStyle()
	const intl = useIntl()
	const isOpen = useSelector((state: RootState) => isModalVisible(state, modalTypes.service))
	const [isSubmitted, setIsSubmitted] = useState<boolean>(false)
	const modalContent: ServiceModalModel = useSelector((state: RootState) => getModalContent(state, modalTypes.service))
	const dispatch = useDispatch()
	const [loading, setLoading] = useState<boolean>(false)

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const formClass: ClassValue = classNames(
		isLargeScreen ? classes.formLargeScreenStyle : classes.formSmallScreenStyle
	)

	const closeModal = () => {
		setIsSubmitted(false)

		dispatch(
			hideModal(modalTypes.service)
		)
	}

	const onSubmit = (values: SpecificationsModel) => {
		setLoading(true)

		const data: DataModel = {
			description: values.message,
			title: modalContent.title,
			id_crm: modalContent.id_crm,
			eft_bienId: contracts.length > 0 && contracts[0].residences.length > 0 ? contracts[0].residences[0] : '',
			eft_Locataire: (contracts.length > 0 && contracts[0].interlocutor) || '',
			eft_BailId: (contracts.length > 0 && contracts[0].id) || ''
		}

		fetchFactory(
			`/api/${intl.locale}/ec_${process.env.REACT_APP_TARGET}/demande/createDemandeService`,
			{
				body: JSON.stringify(data),
				method: configEnum.post
			}
		)
			.then(
				() => setIsSubmitted(true)
			)
			.catch(
				(err) => dispatch(errorCatcher(err, ERROR_CATCHER_ID))
			)
			.finally(
				() => setLoading(false)
			)
	}

	const validate = (values: SpecificationsModel) => {
		const errors: any = {}

		if (!values.message) {
			errors.message = intl.formatMessage(
				{
					id: 'global.errors.required',
					defaultMessage: 'Requis*',
					description: 'Required message'
				}
			)
		}

		return errors
	}

	return (
		<>
			<Dialog
				onCloseDialog={closeModal}
				open={isOpen}
			>
				<>
					<Header
						closeDialog={closeModal}
						fromType={modalTypes.service}
						title={modalContent.title}
						displaySubheader={!isSubmitted}
					/>

					{
						!isSubmitted ? (
							<div className={formClass}>
								<RequestForm
									loading={loading}
									onSubmit={onSubmit}
									validate={validate}
									fromType={modalTypes.service}
								/>
							</div>
						) : (
							<RequestSummary
								title={
									<FormattedMessage
										id="services.modal.summary.title"
										defaultMessage="Votre demande a bien été prise en compte."
										description="Summary title"
									/>
								}
								text={
									<FormattedMessage
										id="services.modal.summary.text"
										defaultMessage="Nous revenons vers vous dans les meilleurs délais concernant le service qui a suscité votre intérêt."
										description="Summary text"
									/>
								}
								closeDialog={closeModal}
								fromType={modalTypes.service}
							/>
						)
					}
				</>
			</Dialog>
		</>
	)
}

const mapStateToProps = (state: RootState) => (
	{
		contracts: state.contracts
	}
)

export default connect(mapStateToProps)(ServiceModal)
